import React from 'react';
import classnames from 'classnames';
import Icon from 'shared/components/icon';
import 'stylesheets/components/shared-tooltip.scss';

interface Props {
  className?: string;
  size?: number;
  blue?: boolean;
  white?: boolean;
}

const InfoIcon = ({className, size = 18, blue = false, white = false}: Props) => (
  <Icon
    iconType="info-circle-r"
    style={{fontSize: `${size}px`}}
    className={classnames('shared-tooltip-icon', className, {
      'shared-tooltip-icon-blue': blue,
      'shared-tooltip-icon-white': white,
    })}
  />
);

export default InfoIcon;
